import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";

const fetchRecommendationsTextData = async (patientId) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.RECOMMENDATIONS_TEXT_API;
  const requestData = {
    task: "getRecommendationsTextForUser",
    user_id: patientId,
  };
  
  const response = await axios.post(url, requestData, headers);
  console.log("Recommendation API Response:", response.data);
  
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  
  return response.data;
};

export const useRecommendationsTextData = (patientId) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["recommendationsTextData", patientId], // Unique key for this query
    queryFn: () => fetchRecommendationsTextData(patientId), // Function to fetch data
    staleTime: 1000 * 60 * 60 * 6, // Data is considered fresh for 6 hour
    cacheTime: 1000 * 60 * 60 * 6, // Cache data for 6 hour
    enabled: !!patientId, // Only run query if patientId is provided
  });
};

